<template>
<div id="app">
  <body>
    <div class="main-content columns is-multiline is-gapless is-fullheight">
      <div class="column is-12">
        <navbar />
      </div>
      <div class="column is-one-fifth">
        <div class="sticky">
        <side-menu />
        </div>
      </div>
      <div class="column is-four-fifths">
        <div class="columns">
          <div class="column is-1"></div>
          <div class="column is-10">
            <router-view />
          </div>
          <div class="column is-1"></div>
        </div>
      </div>
    </div>
  </body>
</div>
</template>
<script>
import SideMenu from "@/components/SideMenu";
import Navbar from "@/components/Navbar";
import { codemirror } from "vue-codemirror";

// require styles
import "codemirror/lib/codemirror.css";

// require more codemirror resource...
// component
export default {
  components: {
    codemirror,
    SideMenu,
    Navbar
  }
};
console.log(process.env.VUE_APP_NAME)
</script>>
<style lang="scss">
html,
body {
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  height: 100vh;
}


$menu-item-active-background-color: hsl(171, 100%, 41%);
$menu-item-color: #777777;

$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome";

@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #00d1b2;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
